import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { TableColumn } from 'src/app/components/common/common-table/common-table.component';
import { CustomReportRequestItem } from 'src/app/models/custom-report-request';
import { DataService } from 'src/app/services';

@Component({
  selector: 'app-custom-report-request-list-janus',
  templateUrl: './custom-report-request-list-janus.component.html',
  styleUrls: ['./custom-report-request-list-janus.component.css'],
  standalone: false
})
export class CustomReportRequestListJanusComponent implements OnInit, OnDestroy {

  @Input() customReportId: string;
  @Input() userId: string;
  queuedReports: CustomReportRequestItem[];
  runningReports: { [key: string]: CustomReportRequestItem };
  intervalSub = null;

  columns: TableColumn[] = [];
  rows: any[] = [];
  constructor(private _dataSvc: DataService) {}

  ngOnDestroy(): void {
    if(this.intervalSub) {
      clearInterval(this.intervalSub);
    }
  }

  ngOnInit() {
    this.columns = [
      {
        key: 'queuedOnString',
        label: 'Requested On',
        hideMenu: true,
        headerType: 'text',
        cellType: 'text'
      },
      {
        key: 'queuedByUser',
        label: 'Requested By',
        hideMenu: true,
        headerType: 'text',
        cellType: 'text'
      },
      {
        key: 'status',
        label: 'Status',
        hideMenu: true,
        headerType: 'text',
        cellType: 'text'
      },
      {
        key: 'completedOnString',
        label: 'Completed On',
        hideMenu: true,
        headerType: 'text',
        cellType: 'text'
      },
      {
        key: 'documentPath',
        label: 'Output',
        hideMenu: true,
        headerType: 'text',
        cellType: 'component',
        // component: ClickableCellComponent,
        // componentInputs: row => ({
        //   text: row.documentPath ? 'View Document' : '',
        //   row: row
        // }),
        // componentOutputs: {
        //   clicked: row => {
        //     if (row.documentPath) {
        //       window.open(row.documentPath, '_blank');
        //     }
        //   }
        // }
      }
    ];

    this.refresh();
  }

  refresh() {
    this._dataSvc
      .getCustomReportRequests(this.customReportId, this.userId)
      .subscribe(reports => {
        this.queuedReports = reports;
        this.rows = reports;

        this.runningReports = {};

        // update the running reports data
        reports
          .filter(r => r.status == 'Running' || r.status == 'Requested')
          .forEach(r => {
            this.runningReports[r.id] = r;
          });

        if (this.intervalSub) {
          clearInterval(this.intervalSub);
        }

        this.intervalSub = setInterval(() => {
          this.updateStatus();
        }, 3000);
      });
  }

  updateStatus() {
    if (this.runningReports) {
      const keys = Object.keys(this.runningReports);
      if (keys.length > 0) {
        const requestIds = {};

        keys.forEach(k => {
          requestIds[k] = this.runningReports[k].status;
        });

        this._dataSvc
          .getCustomReportRequestDetails(requestIds)
          .subscribe((reportDetails: CustomReportRequestItem[]) => {
            if (reportDetails) {
              reportDetails.forEach(rd => {
                if (this.runningReports[rd.id]) {
                  this.runningReports[rd.id].status = rd.status;
                  this.runningReports[rd.id].documentPath = rd.documentPath;
                  this.runningReports[rd.id].completedOnString = rd.completedOnString;
                  if (rd.status == 'Failed' || rd.status == 'Complete') {
                    delete this.runningReports[rd.id];
                  }
                }
              });
            }
          });
      }
    }
  }

}
